import RunnerSafeType from "../../enums/RunnerSafeType.js";

// @see https://www.mlb.com/glossary/standard-stats/runs-batted-in
// @see https://baseball.fandom.com/wiki/Run_batted_in
// In baseball statistics, a run batted in (RBI) is given to a batter for each run scored as the result of a batter's plate appearance.
// There are certain exceptions: a player does not receive an RBI if he hits into a double play and a run scores, if a run is scored on a wild pitch or passed ball or as the result of an error, or if the pitcher balks. A player does receive an RBI if he is walked or hit by a pitch with the bases loaded. He will also receive an RBI if a runner scores from his sacrifice fly or sacrifice bunt.
const classifiesAsRunBattedIn = function(runnerSafe) {
    switch (runnerSafe) {
        case RunnerSafeType.OnLastPlay.key:
        case RunnerSafeType.OnThrow.key:
        case RunnerSafeType.Safe.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsRunBattedIn;